import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { showImportablesDialog } from 'app/main/components/importables/ImportablesDialog';

import MarketingActionsRowsAddSingleDialog from '../../marketingactions-rows/MarketingActionsRowsAddSingleDialog';
import MarketingActionsRowsAddFilterDialog from '../../marketingactions-rows/MarketingActionsRowsAddFilterDialog';
import MarketingActionsRowsAddQueryDialog from '../../marketingactions-rows/MarketingActionsRowsAddQueryDialog';
import MarketingActionsRowsImportDialog from '../../marketingactions-rows/MarketingActionsRowsImportDialog';

interface MarketingActionsDetailsSectionAddRowsProps {
	maacUid: string;
	table: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function MarketingActionsDetailsSectionAddRows(props: MarketingActionsDetailsSectionAddRowsProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.table);

	const [openAddRowDialog, setOpenAddRowDialog] = React.useState(false);
	const switchOpenAddRowDialog = () => setOpenAddRowDialog(state => !state);

	const [openAddFilterRowsDialog, setOpenAddFilterRowsDialog] = React.useState(false);
	const switchOpenAddFilterRowsDialog = () => setOpenAddFilterRowsDialog(state => !state);

	const [openAddQueryRowsDialog, setOpenAddQueryRowsDialog] = React.useState(false);
	const switchOpenAddQueryRowsDialog = () => setOpenAddQueryRowsDialog(state => !state);

	const [openImportDialog, setOpenImportDialog] = React.useState(false);
	const switchOpenImportDialog = () => setOpenImportDialog(state => !state);

	const showAddDialog = () => {
		dispatch(
			showFastAddDialog({
				module: props.table,
				model: { [`${settings.modu_short}_maac_uid`]: props.maacUid },
				updateRefresh: props.updateRefresh
			})
		);
	};

	const showImportFileDialog = () =>
		dispatch(
			showImportablesDialog({
				module: 'marketingactions_rows',
				params: { maac_uid: props.maacUid },
				updateRefresh: props.updateRefresh
			})
		);

	return (
		<>
			<DetailsSectionWrapper
				classes={{ content: 'py-0 last:py-0' }}
				title={t('MAAC_SECTION_ADD_TITLE')}
				actions={
					<Grid container>
						<Grid size={12}>
							<Button
								startIcon={<Icon icon="new-box" />}
								onClick={showAddDialog}
								disabled={props.isLoading}
							>
								{t('VIEW_HEADER_BUTTON_NEW')}
							</Button>
							<Button
								startIcon={<Icon icon="file-upload" />}
								onClick={showImportFileDialog}
								disabled={props.isLoading}
							>
								{t('IMPORT_FILE')}
							</Button>
						</Grid>
						<Grid size={12}>
							<Button
								startIcon={<Icon icon="search" />}
								onClick={switchOpenAddRowDialog}
								disabled={props.isLoading}
							>
								{t('SEARCH_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="filter" />}
								onClick={switchOpenAddFilterRowsDialog}
								disabled={props.isLoading}
							>
								{t('FILTER_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="file-tree" />}
								onClick={switchOpenAddQueryRowsDialog}
								disabled={props.isLoading}
							>
								{t('FILTER_QUERY_BUILDER_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="table-import" />}
								onClick={switchOpenImportDialog}
								disabled={props.isLoading}
							>
								{t('IMPORT_BUTTON')}
							</Button>
						</Grid>
					</Grid>
				}
			>
				{t(`MAAC_SECTION_ADD_DESCRIPTION_${props.table}`)}
			</DetailsSectionWrapper>
			{/* ADD SINGLE ROW DIALOG */}
			<MarketingActionsRowsAddSingleDialog
				openDialog={openAddRowDialog}
				switchOpenDialog={switchOpenAddRowDialog}
				maacUid={props.maacUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD ROWS FILTER DIALOG */}
			<MarketingActionsRowsAddFilterDialog
				openDialog={openAddFilterRowsDialog}
				switchOpenDialog={switchOpenAddFilterRowsDialog}
				maacUid={props.maacUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD ROWS ADVANCED FILTER DIALOG */}
			<MarketingActionsRowsAddQueryDialog
				openDialog={openAddQueryRowsDialog}
				switchOpenDialog={switchOpenAddQueryRowsDialog}
				maacUid={props.maacUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* IMPORT ROWS DIALOG */}
			<MarketingActionsRowsImportDialog
				openDialog={openImportDialog}
				switchOpenDialog={switchOpenImportDialog}
				maacUid={props.maacUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
		</>
	);
}
